import { atom } from "recoil";

const isLoginAtom = atom({
  key: "isLogin",
  // get initial state from local storage to enable user to stay logged in
  default: false,
});

export { isLoginAtom };
